import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTASection = () => {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden" data-testid="final-cta">
      <div className="container-px py-20 lg:py-28">
        <div className="relative overflow-hidden rounded-[2rem] border border-orange-500/20 bg-[#1C1C20] p-10 text-center sm:p-16 lg:p-20">
          <div className="hatch-diag absolute inset-0 opacity-60" />
          <div className="radial-glow absolute inset-0" />
          <div className="relative">
            <Reveal>
              <p className="kicker mb-5 flex justify-center gap-2">From Vision to Victory</p>
            </Reveal>
            <Reveal i={1}>
              <h2 className="mx-auto max-w-3xl font-head text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
                Let's Hatch Your India Growth Story.
              </h2>
            </Reveal>
            <Reveal i={2}>
              <p className="mx-auto mt-6 max-w-xl text-base text-zinc-400 sm:text-lg">
                Ideas Hatch. Teams Grow. Businesses Scale. Book a free consultation and we'll map
                the right path for your India expansion.
              </p>
            </Reveal>
            <Reveal i={3}>
              <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <button onClick={() => navigate("/contact")} className="btn-primary" data-testid="cta-book-consultation">
                  Book a Free Consultation <ArrowRight className="h-4 w-4" />
                </button>
                <button onClick={() => navigate("/assessment")} className="btn-ghost" data-testid="cta-take-assessment">
                  Take the India Readiness Assessment™
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
